import { render, staticRenderFns } from "./SelectedChunks.vue?vue&type=template&id=7fe1f4e6&scoped=true"
import script from "./SelectedChunks.vue?vue&type=script&lang=js"
export * from "./SelectedChunks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1f4e6",
  null
  
)

export default component.exports